$(function () {

    if (!$('#translation-payment-form').length) return;

    const translation_id = getURLParameter("translation_id");
    const key = getURLParameter("key");
    const fullPayment = getURLParameter("fullpayment");

    const pageContainer = $(".translation-payment-page")[0];

    let translation;

    let minPayment = 0;

    if (!translation_id || !key) { // missing URL parameter
        getTranslationFailed();
        return;
    }

    // retrieve the original translation request to fill up the form 
    var fieldsFormats = {
        "created_at": "datetime",
        "updated_at": "datetime",
        "request_quote": "boolean",
        "day_required": "day_required",
    };

    // display loader
    $(pageContainer).prepend('<div class="loader-overlay"><div class="spinner-grow page-loader"></div></div>');

    // make request to API
    $.ajax({
        type: "GET",
        url: `${getApiURL('translations')}/${translation_id}/key/${key}?responseGroups=FILES`,
        dataType: "json",
        success: function (object) {
            translation = object;
            populateObjectData(pageContainer, translation, '', fieldsFormats);

            // display nicely the status
            $('[data-name=status]').html(label_status(translation));

            // payment ref
            $("#reference").val(translation.ref);

            // deposit amount
            if (!fullPayment) {
                minPayment = translation.client_fees;
                $("[data-name=half_fees]").text(minPayment);
                $("#amount").attr("min", minPayment).val(minPayment);
            }

            // files list
            translation.translation_files.forEach(file => {
                $("#translation-files-list").append(
                    `<li>${file.file} FROM ${file.language_from} TO ${file.language_to}</li>`
                );
            });

            // add confirm button
            $(".actions").append(`<button class="btn btn-confirmation" id="save-payment-info" value="Confirm">Confirm</button>`);

            $(pageContainer).find(".loader-overlay").remove();
        },
        error: function (request, textStatus, errorThrown) {
            getTranslationFailed();
        }
    });

    function getTranslationFailed() {
        $(pageContainer).hide();
        ATLAlerts.addError("Sorry, we couldn't retrieve the translation request you are looking for.");
        $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
        $(pageContainer).find(".loader-overlay").remove();
    }

    $("#card-radio").on('click', function (e) {
        $(".card-row").show();
        $(".eft-row").hide();
        $(".cheque-row").hide();
        $(".not-eft-row").show();
    });

    $("#eft-radio").on('click', function (e) {
        $(".card-row").hide();
        $(".eft-row").show();
        $(".cheque-row").hide();
        $(".not-eft-row").hide();
    });

    $("#cheque-radio").on('click', function (e) {
        $(".card-row").hide();
        $(".eft-row").hide();
        $(".cheque-row").show();
        $(".not-eft-row").show();
    });

    $("#use_same_card").on('change', function (e) {
        if ($(this).is(":checked")) {
            if (document.getElementById("deposit-card-type").value !== "Visa") {
                document.getElementById("visa-radio").removeAttribute("checked");
                document.getElementById("mastercard-radio").setAttribute("checked", "");
            }
            else {
                document.getElementById("mastercard-radio").removeAttribute("checked");
                document.getElementById("visa-radio").setAttribute("checked", "");
            }
            $("#card-nb").val(document.getElementById("deposit-card-number").value);
            $("#card-expiry").val(document.getElementById("deposit-card-expiry-date").value);
            $("#card-holder").val(document.getElementById("deposit-card-holder").value);
        }
        else {
            document.getElementById("visa-radio").removeAttribute("checked");
            document.getElementById("mastercard-radio").setAttribute("checked", "");
            $("#card-nb").val("");
            $("#card-expiry").val("");
            $("#card-holder").val("");
        }
    });


    $(".actions").on("click", "#save-payment-info", function (e) {
        e.preventDefault();

        const form = $('#translation-payment-form');
        const formData = getFormData(form);

        if (formData["payment_method"] === "card") {
            if (!formData["card_number"]) {
                alert('Please fill out the card number field.');
                return false;
            }
            if (!formData["card_expiry_date"]) {
                alert('Please fill out the card expiry date field.');
                return false;
            }
            if (!formData["card_holder"]) {
                alert('Please fill out the card holder field.');
                return false;
            }
        }

        formData["amount"] = Number(formData["amount"]);

        if (isNaN(formData["amount"]) || formData["amount"] < minPayment) {
            alert('Please fill out the amount field with correct value.');
            return false;
        }

        // format payment date for EFT
        formData["payment_date"] = moment(formData["transfer_date"], "DD/MM/YYYY").format("YYYY-MM-DD");

        // console.debug(formData);

        const dialog = showConfirmationDialog({
            title: `Save payment details for Translation Request ${translation.ref}?`,
            body: `Are you sure you want to submit this information?`,
            confirmButton: {
                title: "Proceed",
                onClick: function () {
                    $.ajax({
                        type: "POST",
                        url: `${getApiURL("translations")}/${translation_id}/key/${key}/payment`,
                        headers: { "Token": $.cookie('token_api') },
                        data: formData,
                        dataType: "json",
                        success: function () {
                            dialog.modal('hide');
                            if (formData["payment_method"] === "eft") {
                                if (translation.request_quote) {
                                    ATLAlerts.addSuccess(`Thank you for approving the quote. Please do not forget to email your transfer receipt to us as soon as possible.`);
                                }
                                else {
                                    ATLAlerts.addSuccess(`Thank you for providing your payment details. Please do not forget to email your transfer receipt to us as soon as possible.`);
                                }
                            }
                            else {
                                ATLAlerts.addSuccess(`Your payment details for the translation request ${translation.ref} have been successfully sent. You will be advised when the payment has been processed.`);
                            }
                            $(pageContainer).hide();
                            $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
                        },
                        error: function (request, textStatus, errorThrown) {
                            alert("Something went wrong: " + errorThrown);
                            dialog.modal('hide');
                        }
                    });
                },
            },
        });
    });

});